import {TFnType} from 'tolgee';

import {AnyLabelledItem, getAliasFromItems} from '~utils/miscUtils';
import {CurationMeta, LabelItem} from '~redux/types/images';
import {Model} from '~redux/types/models';

import {getModelName} from '~components/models/models.utils';

const CURATION_CHIP_I18N_KEY: Record<string, string> = {
  overkill: 'curationChip.overkill',
  escape: 'curationChip.escape',
  low_polygon_overlap: 'curationChip.lowPolygonOverlap',
  anomaly: 'curationChip.anomaly',
  unstable_prediction_ood: 'curationChip.dataNovelty',
  unstable_prediction_uncertain: 'curationChip.modelUncertainty',
  defect_similarity: 'curationChip.defectSimilarity',
  model_uncertainty: 'curationChip.modelUncertainty',
  data_novelty: 'curationChip.dataNovelty',
};

export function curationChipName(t: TFnType, moduleKey: string | undefined): string | undefined {
  if (!moduleKey) {
    return undefined;
  }
  const key = CURATION_CHIP_I18N_KEY[moduleKey];
  return key ? t(`${key}.name`, {ns: 'review'}) : undefined;
}

export function curationChipMessage(
  t: TFnType,
  curationMeta: CurationMeta | null | undefined,
  language: string,
  labelItems: LabelItem[],
  models: Model[],
): string | null {
  if (!curationMeta) {
    return null;
  }
  const key = curationMeta.module ? CURATION_CHIP_I18N_KEY[curationMeta.module] : undefined;
  if (key) {
    const classLabelId = curationMeta.class_name;
    const modelId = curationMeta.meta?.model_id;
    return t(`${key}.message`, {
      ns: 'review',
      className: classLabelId ? getAliasFromItems(classLabelId, labelItems as AnyLabelledItem[]) : '',
      modelId: (modelId ? getModelName(modelId, models) : undefined) ?? modelId ?? '',
    });
  }
  return (language.startsWith('de') ? curationMeta.hint_de : undefined) ?? curationMeta.hint_en ?? null;
}
